import { Component } from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const msg = this.state.error?.message || String(this.state.error || "Erreur inconnue");
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-4" data-testid="error-boundary">
          <div className="max-w-lg w-full bg-cyber-surface border border-neon-red/30 rounded-xl p-5 space-y-4 neon-glow-red">
            <div className="flex items-center gap-3">
              <AlertTriangle className="w-6 h-6 text-neon-red shrink-0" />
              <h2 className="font-heading text-white text-lg">Une erreur est survenue</h2>
            </div>
            <p className="text-sm text-muted-foreground font-mono">
              La page n'a pas pu s'afficher correctement. Essayez de recharger ou revenez en arrière.
            </p>
            <pre className="text-[11px] font-mono text-neon-red bg-neon-red-muted/30 border border-neon-red/20 rounded-lg p-3 overflow-auto max-h-40 whitespace-pre-wrap break-words">
              {msg}
            </pre>
            <div className="flex gap-2">
              <Button onClick={this.handleReset} variant="outline" className="border-neon-blue/20 rounded-lg flex-1 bg-transparent" data-testid="error-retry">
                <RotateCcw className="w-4 h-4 mr-2" />
                Reessayer
              </Button>
              <Button onClick={this.handleReload} className="bg-gradient-to-r from-neon-blue to-neon-purple text-white font-bold rounded-lg flex-1 neon-glow-blue" data-testid="error-reload">
                Recharger la page
              </Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
